<template>
  <div class="c-item-list">
    <div v-for="(item, key) in items" :key="key" class="c-item-list__panel">
      <ItemListPanel
        :id="item.premium.id"
        :img-path="item.premium.premiumimage_set[0].image_url"
        :name="item.premium.name"
        :point="item.point_required"
        :discount-rate="item.discount_rate"
        :is-favorite="item.premium.is_featured"
        :stock="item.quantity"
        :stock-control="item.is_quantity_control"
        :color="getColor(item)"
        :status="status(item)"
        :add-to-browser-history="addToBrowserHistory"
      />
    </div>
  </div>
</template>

<script lang="ts">
import commons from "@/common/store/modules/commons";
import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import items from "@/general/store/modules/items";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    items: { type: Array, required: true },
    addToBrowserHistory: { type: Boolean, default: false }
  },
  components: {
    ItemListPanel
  }
})
export default class ItemList extends Vue {
  items!: any;
  addToBrowserHistory!: boolean;

  status(item: any) {
    if (item?.is_quantity_control && item.quantity == 0) {
      //out of stock
      return "在庫なし";
    } else if (item.premium.is_new === true) {
      //New
      return "New";
    } else if (item.premium.is_featured === true) {
      //Recommended
      return "おすすめ";
    } else {
      //show nothing
      return false;
    }
  }

  getColor(item: any) {
    return item.is_quantity_control && item.quantity == 0
      ? "#333"
      : commons.colorCode;
  }
}
</script>

<style lang="scss" scoped>
.c-item-list {
  display: flex;
  flex-wrap: wrap;
  margin: rem(-16) rem(-16) 0 0;

  @include sp {
    margin: rem(-8) rem(-8) 0 0;
  }

  &__panel {
    @include pc {
      padding: rem(16) rem(16) 0 0;
      width: rem(244);
      max-width: 25%;
    }

    @include sp {
      padding: rem(8) rem(8) 0 0;
      width: 50%;
    }
  }
}
</style>
